import { getWorkCommentField } from './work-comment-step';
import { getParticipantFields } from './work-user-type-step';
import { getWorkContentFields } from './work-fields';

let changeParamInput;

const commentStep     = 'comment';
const participantStep = 'participant';
const workContentStep = 'workContent';

function getFieldsForStep(step) {
  let fields = {};

  switch (step) {
    case commentStep:
      fields = getWorkCommentField();

      break;
    case participantStep:
      fields = getParticipantFields();

      break;
    case workContentStep:
      fields = getWorkContentFields();

      break;
  }

  return fields;
}

function setNotChangedForm() {
  const notChanged = 'not-changed';
  const applicationForm = document.querySelector('.application-form');

  if (applicationForm) {
    const changeParam = applicationForm.querySelector('input[name="application-form-changed"]');
    changeParam.value = notChanged;
  }
}

async function initSaveWorkBetweenStep() {
  const applicationForms = document.querySelectorAll('.application-form');
  changeParamInput = document.querySelector('input[name="application-form-changed"]');

  if (!applicationForms.length || !changeParamInput) {
    return;
  }

  const activeStepMenuItem = document.querySelector('.edit-menu__link_active');
  const activeLi = activeStepMenuItem?.parentNode;
  const step = activeLi?.getAttribute('data-edit-step') ?? '';
  // @KLUDGE Проверяем что страница была перезагружена, значит надо запросить новые данные формы. Для этого делаем
  // повторную загрузку страницы через запрос, а не reload.
  const versionBaseUrl = changeParamInput.getAttribute('data-url');
  const stepVersion = changeParamInput.getAttribute('data-version');
  console.log('save-beetween-steps stepVersion');
  console.log(stepVersion);

  if (
    typeof versionBaseUrl === 'string' &&
    versionBaseUrl !== '' &&
    stepVersion !== null &&
    stepVersion !== '' &&
    step !== ''
  ) {
    const versionUrl =
      versionBaseUrl +
      '?step=' +
      encodeURIComponent(step) +
      '&version=' +
      encodeURIComponent(stepVersion);

    console.log('save-beetween-steps versionUrl');
    console.log(versionUrl);

    const response = await fetch(versionUrl);
    const result = await response.json();
    console.log('save-beetween-steps response result');
    console.log(result);

    if (result.status === 'success' && result.redirectTo?.length) {
      console.log('save-beetween-steps redirect');
      if (typeof window.__showWbStepLoader === 'function') {
        window.__showWbStepLoader();
      }
      window.location.href = result.redirectTo;
    }
  }

  applicationForms?.forEach(function (form) {
    const markChanged = function () {
      const changeParam = form.querySelector('input[name="application-form-changed"]');
      if (changeParam) {
        changeParam.value = 'changed';
      }
    };

    form.addEventListener('input', markChanged);
    form.addEventListener('change', markChanged);
  });

  document.addEventListener('visibilitychange', async function (event) {
    const applicationForm = document.querySelector('.application-form');

    if (applicationForm && document.hidden) {
      const changeParam = applicationForm.querySelector('input[name="application-form-changed"]');
      const beaconUrl = activeLi?.getAttribute('data-save-draft-url');

      // Для шага участника пробуем сохранить данные, даже если они не редактировались
      // Чтобы проверить их и перевести шаг из черновика в валидный
      if (!beaconUrl || changeParam.value !== 'changed') {
        return;
      }

      let stepfields;

      try {
        stepfields = getFieldsForStep(step);
      } catch (error) {
        console.error('save-beetween-steps fields', error);
        return;
      }

      // application/json sendBeacon не отправляет: это не CORS-safelisted Content-Type.
      const data = new Blob([JSON.stringify(stepfields)], {type: 'text/plain;charset=UTF-8'});
      navigator.sendBeacon(beaconUrl, data);
    }
  });
}

export { initSaveWorkBetweenStep, setNotChangedForm }